import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="flex min-w-0 flex-1 items-center justify-center">
      <title>Not Found | Talent Service</title>
      <div className="w-full min-w-0 max-w-lg space-y-8 text-center sm:space-y-10">

        {/* Animated 404 illustration */}
        <div className="relative select-none">
          {/* Background glow */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-48 h-48 bg-primary-500/10 dark:bg-primary-400/5 rounded-full blur-3xl" />
          </div>

          {/* Large 404 number */}
          <div className="relative">
            <h1
              className="text-[7rem] font-black leading-none tracking-tighter text-light-bg-tertiary dark:text-dark-bg-tertiary sm:text-[10rem]"
              style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
            >
              404
            </h1>

            {/* Floating compass icon overlay */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-20 w-20 bg-gradient-to-br from-primary-500 to-primary-700 dark:from-primary-400 dark:to-primary-600 rounded-2xl rotate-12 flex items-center justify-center shadow-xl shadow-primary-500/20">
                <svg
                  className="h-10 w-10 text-white -rotate-12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" fill="currentColor" opacity="0.3" />
                  <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="space-y-3">
          <h2 className="text-2xl font-bold text-light-text-primary dark:text-dark-text-primary">
            Lost in space
          </h2>
          <p className="text-sm text-light-text-tertiary dark:text-dark-text-tertiary max-w-xs mx-auto leading-relaxed">
            The page you're looking for doesn't exist or has been moved to a different location.
          </p>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-3 max-w-xs mx-auto">
          <Link
            to="/"
            className="flex-1 inline-flex items-center justify-center px-5 py-3 text-sm font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-650 dark:hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors shadow-md shadow-primary-600/20"
          >
            <Home className="h-4 w-4 mr-2" />
            Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="flex-1 inline-flex items-center justify-center px-5 py-3 border border-light-border-primary dark:border-dark-border-primary text-sm font-medium rounded-lg text-light-text-secondary dark:text-dark-text-secondary bg-light-bg-primary dark:bg-dark-bg-secondary hover:bg-light-bg-tertiary dark:hover:bg-dark-bg-tertiary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </button>
        </div>

        {/* Footer note */}
        <p className="text-xs text-light-text-tertiary/60 dark:text-dark-text-tertiary/60">
          Error 404 &middot; Not Found
        </p>
      </div>
    </div>
  )
}

export default NotFound
